import { useEffect, useMemo, useState } from "react";
import useAllCollections from "domains/collections/hooks/useAllCollections";

export default function useAssetFilterCollection() {
  const [collectionId, setCollectionId] = useState<string | undefined>();
  const { collections, isLoading } = useAllCollections();

  const options = useMemo(
    () =>
      collections.map((collection) => ({
        label: collection.name,
        value: collection.id,
      })),
    [collections]
  );

  useEffect(() => {
    if (
      collectionId &&
      options.findIndex(({ value }) => value === collectionId) === -1
    ) {
      setCollectionId(undefined);
    }
  }, [collectionId, options]);

  return {
    allAssetsCollectionArgs: {
      collectionId,
    },
    assetFileManagerCollectionOptions: {
      filterAssetCollection: collectionId,
      filterAssetCollectionOptions: options,
      isFilterAssetCollectionLoading: isLoading,
      onFilterAssetCollectionChange: setCollectionId,
    },
    fmHeaderCollectionProps: {
      value: collectionId,
      options: options,
      isLoading: isLoading,
      onChange: options.length ? setCollectionId : () => {},
    },
  };
}
